const accessibilityColors = {
  none: '#FFF',
  pqtg: '#FBFEB8'
}

const backgroundColors = {
  none: { color: '#0078D4', contrasting: '#FFF' },
  sqyi: { color: '#25408F', contrasting: '#FFF' },
  wyhs: { color: '#69479A', contrasting: '#FFF' },
  vpgd: { color: '#075F20', contrasting: '#FFF' },
  uueb: { color: '#A4262C', contrasting: '#FFF' },
  nsok: { color: '#E55A00', contrasting: '#FFF' },
  ysdm: { color: '#FAFAFA', contrasting: '#333' }
}

const accessibilityColorsList = ['none', 'pqtg']
const backgroundColorsList = [
  'none',
  'sqyi',
  'wyhs',
  'vpgd',
  'uueb',
  'nsok',
  'ysdm'
]

export {
  accessibilityColors,
  accessibilityColorsList,
  backgroundColors,
  backgroundColorsList
}
